(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~notification"],{

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/base/vc-notification/index.js + 2 modules
var vc_notification = __webpack_require__(105);

// CONCATENATED MODULE: ./src/components/notification/util.js
var isDef = function isDef(v) {
  return v !== undefined && v !== null;
};
var isFunc = function isFunc(v) {
  return typeof v === 'function';
};
var isNumber = function isNumber(v) {
  return typeof v === 'number';
};
function getPlacementStyle(placement) {
  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "24px";
  var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "24px";
  var style;

  switch (placement) {
    case "topLeft":
      style = {
        left: 0,
        top: top,
        bottom: "auto"
      };
      break;

    case "topRight":
      style = {
        right: 0,
        top: top,
        bottom: "auto"
      };
      break;

    case "bottomLeft":
      style = {
        left: 0,
        top: "auto",
        bottom: bottom
      };
      break;

    default:
      style = {
        right: 0,
        top: "auto",
        bottom: bottom
      };
      break;
  }

  return style;
}
// CONCATENATED MODULE: ./src/components/notification/assets/close.png
/* harmony default export */ var assets_close = ("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAKBJREFUOE9jZKAQMFKonwHFABERdd43b25+xmeoqKgWz+vX177A1MANAEkwM//u+v+fYeHLl7dPYjNEXFzVnJGRIf7PH6ZymEUoLoApwGYILjmMMMCmEJ/BWAMRWQPIKyBn4/IazliAGQIyAF+4EDDgfxzIfpINoMgLFAUiRdEISoUsLP86iUlIf/+ylsFSI0ogoidTbKkRPblTNzORkzMBwd2JEVNwcZcAAAAASUVORK5CYII=");
// CONCATENATED MODULE: ./src/components/notification/assets/error.svg
/* harmony default export */ var assets_error = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KICA8c3ZnIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHBhdGggcGlkPSIwIiBkPSJNOCAwQzMuNiAwIDAgMy42IDAgOHMzLjYgOCA4IDggOC0zLjYgOC04LTMuNi04LTgtOHptMyAxMUg5LjhMOCA4LjkgNi4yIDExSDVzLS4xIDAtLjEtLjF2LS4xTDcuMyA4IDQuOSA1LjN2LS4xYzAtLjEuMS0uMi4xLS4yaDEuMkw4IDcuMiA5LjggNUgxMWMuMSAwIC4xLjEuMS4xdi4xTDguNyA4bDIuMyAyLjh2LjFjLjEuMSAwIC4xIDAgLjF6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0U1MzYzNSIgZmlsbC1vcGFjaXR5PSIxIi8+CiAgPC9zdmc+CiAg");
// CONCATENATED MODULE: ./src/components/notification/assets/succ.svg
/* harmony default export */ var succ = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KICA8c3ZnIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHBhdGggcGlkPSIwIiBkPSJNOCAwQzMuNiAwIDAgMy42IDAgOHMzLjYgOCA4IDggOC0zLjYgOC04LTMuNi04LTgtOHptMy41IDUuNGwtMy44IDUuMmMtLjIuMy0uNy4zLS45IDBMNC41IDcuNWMtLjEtLjEgMC0uMi4xLS4yaC44Yy4yIDAgLjQuMS41LjJsMS4zIDEuOEwxMCA1LjRjLjEtLjEuMy0uMi41LS4yaC44Yy4yIDAgLjIuMS4yLjJ6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzAwQzE3MiIgZmlsbC1vcGFjaXR5PSIxIi8+CiAgPC9zdmc+CiAg");
// CONCATENATED MODULE: ./src/components/notification/assets/info.svg
/* harmony default export */ var assets_info = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KICA8c3ZnIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHBhdGggcGlkPSIwIiBmaWxsPSJub25lIiBkPSJNMCAwaDE2djE2SDB6Ii8+PHBhdGggcGlkPSIxIiBkPSJNOCAwQzMuNiAwIDAgMy42IDAgOHMzLjYgOCA4IDggOC0zLjYgOC04LTMuNi04LTgtOHptLjYgMTEuOWMwIC4xLS4xLjEtLjEuMWgtLjljLS4xIDAtLjEtLjEtLjEtLjFWN2MwLS4xLjEtLjEuMS0uMWguOWMuMSAwIC4xLjEuMS4xdjQuOXpNOCA1LjdjLS41IDAtLjktLjQtLjktLjlTNy41IDQgOCA0cy45LjQuOS45LS40LjgtLjkuOHoiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjMTA2N0QxIiBmaWxsLW9wYWNpdHk9IjEiLz4KICA8L3N2Zz4KICA=");
// CONCATENATED MODULE: ./src/components/notification/assets/warn.svg
/* harmony default export */ var warn = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KICA8c3ZnIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHBhdGggcGlkPSIwIiBkPSJNOCAxNmM0LjQgMCA4LTMuNiA4LThzLTMuNi04LTgtOC04IDMuNi04IDggMy42IDggOCA4ek03LjQgNC4xcy4xLS4xLjItLjFoLjljLjEgMCAuMS4xLjEuMVY5YzAgLjEtLjEuMS0uMS4xaC0uOWMtLjEgMC0uMiAwLS4yLS4xVjQuMXptLjYgNi4yYy41IDAgLjkuNC45LjkgMCAuNC0uNC44LS45LjhzLS45LS40LS45LS45YzAtLjQuNC0uOC45LS44eiIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiNGRjhFMjciIGZpbGwtb3BhY2l0eT0iMSIvPgogIDwvc3ZnPgogIA==");
// CONCATENATED MODULE: ./src/components/notification/index.jsx
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var defaultDuration = 5;
var defaultTop = "24px";
var defaultBottom = "24px";
var defaultPlacement = "topRight";

var defaultGetContainer = function defaultGetContainer() {
  return document.body;
};

var defaultCloseIcon = null;
var notificationInstance = {}; // 全局缓存实例对象

function setNotificationConfig(options) {
  var duration = options.duration,
      placement = options.placement,
      bottom = options.bottom,
      top = options.top,
      getContainer = options.getContainer,
      closeIcon = options.closeIcon;

  if (isDef(duration)) {
    defaultDuration = duration;
  }

  if (isDef(placement)) {
    defaultPlacement = placement;
  }

  if (isDef(bottom)) {
    defaultBottom = isNumber(bottom) ? "".concat(bottom, "px") : bottom;
  }

  if (isDef(top)) {
    defaultTop = isNumber(top) ? "".concat(top, "px") : top;
  }

  if (isDef(getContainer)) {
    defaultGetContainer = getContainer;
  }

  if (isDef(closeIcon)) {
    defaultCloseIcon = closeIcon;
  }
}

function getNotificationInstance(_ref, callback) {
  var prefixCls = _ref.prefixCls,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? defaultPlacement : _ref$placement,
      _ref$getContainer = _ref.getContainer,
      getContainer = _ref$getContainer === void 0 ? defaultGetContainer : _ref$getContainer,
      top = _ref.top,
      bottom = _ref.bottom,
      _ref$closeIcon = _ref.closeIcon,
      _closeIcon = _ref$closeIcon === void 0 ? defaultCloseIcon : _ref$closeIcon;

  var cacheKey = "".concat(prefixCls, "-").concat(placement);

  if (notificationInstance[cacheKey]) {
    callback(notificationInstance[cacheKey]);
    return;
  }

  vc_notification["a" /* default */].newInstance({
    prefixCls: prefixCls,
    class: "".concat(prefixCls, "-").concat(placement),
    style: getPlacementStyle(placement, top, bottom),
    getContainer: getContainer,
    closeIcon: function closeIcon(h) {
      var icon = isFunc(_closeIcon) ? _closeIcon(h) : _closeIcon;
      var closeIconToRender = h("span", {
        "class": "".concat(prefixCls, "-close-x")
      }, [icon || h("img", {
        attrs: {
          src: assets_close,
          alt: "close"
        },
        "class": "".concat(prefixCls, "-close-icon")
      })]);
      return closeIconToRender;
    }
  }, function (notification) {
    notificationInstance[cacheKey] = notification;
    callback(notification);
  });
}

var noticeIconConfig = {
  info: function info(h) {
    return h("img", {
      attrs: {
        src: assets_info
      },
      "class": "meg-modal-warn-icon"
    });
  },
  success: function success(h) {
    return h("img", {
      attrs: {
        src: succ
      },
      "class": "meg-modal-success-icon"
    });
  },
  error: function error(h) {
    return h("img", {
      attrs: {
        src: assets_error
      },
      "class": "meg-modal-error-icon"
    });
  },
  warning: function warning(h) {
    return h("img", {
      attrs: {
        src: warn
      },
      "class": "meg-modal-warn-icon"
    });
  }
};

function notice(args) {
  var icon = args.icon,
      type = args.type,
      description = args.description,
      message = args.message,
      btn = args.btn;
  var outerPrefixCls = args.prefixCls || "meg-notification";
  var prefixCls = "".concat(outerPrefixCls, "-notice");
  var duration = isDef(args.duration) ? args.duration : defaultDuration;
  var iconNode = null;

  if (icon) {
    iconNode = function iconNode(h) {
      return h("span", {
        "class": "".concat(prefixCls, "-icon")
      }, [isFunc(icon) ? icon(h) : null]);
    };
  } else if (type) {
    iconNode = function iconNode(h) {
      return h("span", {
        "class": "".concat(prefixCls, "-icon")
      }, [noticeIconConfig[type](h)]);
    };
  }

  var placement = args.placement,
      top = args.top,
      bottom = args.bottom,
      getContainer = args.getContainer,
      closeIcon = args.closeIcon;
  getNotificationInstance({
    prefixCls: outerPrefixCls,
    placement: placement,
    top: top,
    bottom: bottom,
    getContainer: getContainer,
    closeIcon: closeIcon
  }, function (notification) {
    notification.notice({
      content: function content(h) {
        return h("div", {
          "class": iconNode ? "".concat(prefixCls, "-with-icon") : ""
        }, [iconNode && iconNode(h), h("div", {
          "class": "".concat(prefixCls, "-message")
        }, [!description && iconNode ? h("span", {
          "class": "".concat(prefixCls, "-message-single-line-auto-margin")
        }) : null, isFunc(message) ? message(h) : message]), h("div", {
          "class": "".concat(prefixCls, "-description")
        }, [isFunc(description) ? description(h) : description]), btn ? h("span", {
          "class": "".concat(prefixCls, "-btn")
        }, [isFunc(btn) ? btn(h) : btn]) : null]);
      },
      duration: duration,
      closable: true,
      onClose: args.onClose,
      onClick: args.onClick,
      key: args.key,
      style: args.style || {},
      class: args.class
    });
  });
}

var api = {
  open: notice,
  close: function close(key) {
    Object.keys(notificationInstance).forEach(function (cacheKey) {
      return notificationInstance[cacheKey].removeNotice(key);
    });
  },
  config: setNotificationConfig,
  destroy: function destroy() {
    Object.keys(notificationInstance).forEach(function (cacheKey) {
      notificationInstance[cacheKey].destroy();
      delete notificationInstance[cacheKey];
    });
  }
};
["success", "info", "warning", "error"].forEach(function (type) {
  api[type] = function (args) {
    return api.open(_objectSpread(_objectSpread({}, args), {}, {
      type: type
    }));
  };
});
api.warn = api.warning;
/* harmony default export */ var components_notification = __webpack_exports__["default"] = (api);

/***/ })

}]);